/**
 * This code replicates Tablesaw's stack option. For some reason,
 * tablesaw was running very slowing in IE11, so this custom approach
 * was used. Tablesaw's CSS is still in use, hence why the tablesaw
 * classnames are being used.
 */
const tables = Array.from(document.querySelectorAll('.is-style-responsive-tables > table'));
if (tables.length) {
	tables.forEach((table) => {
		const ths = Array.from(table.querySelectorAll('thead th'));
		const trs = Array.from(table.querySelectorAll('tbody tr'));
		if (ths.length && trs.length) {
			trs.forEach((tr) => {
				const tds = tr.querySelectorAll('td');
				if (tds.length === ths.length) {
					tds.forEach((td, i) => {
						td.innerHTML = `
							<b class="tablesaw-cell-label">${ths[i].innerText}</b>
							<span class="tablesaw-cell-content">${td.innerHTML}</span>
						`;
					});
				}
			});
		}
	});
}
